import { render, staticRenderFns } from "./afterVerifyOk.vue?vue&type=template&id=844cdb6c"
import script from "./afterVerifyOk.vue?vue&type=script&lang=js"
export * from "./afterVerifyOk.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports